module.exports = __webpack_public_path__ + "img/stock0.d68d1510.png";